import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import {
    Card,
    Table,
    Divider,
    Popconfirm,
    Input,
    Button,
    Icon
} from 'antd';

import {
    _paginateSlaDiscprencies,
    _deleteSla
} from '../../services'

import { ADMIN_URL } from '../../index';

let allowedEditors = [
    'julian.siew@eezee.com.sg',
    'ryan.fernandez@eezee.com.sg',
    'bong.dy-liacco@eezee.com.sg',
    'sue.yusro@eezee.com.sg',
    'arfika.aisyah@eezee.com.sg',
    'kengyong.quek@eezee.com.sg',
    'ken.lok@eezee.com.sg',
    'sakina.sam@eezee.com.sg'
]

class SlaDiscrepenciesTable extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            data:  [],
            limit: 40,
            page: 1,

            offlineReferenceNumber_search: '',
            fdTicketNum_search: '',
            supplierCompanyName_search: '',
            enterpriseCompanyName_search: ''
        }
    }

    render() {

        return  (
            <Card title='SLA Discrepencies' bodyStyle={{padding: 0}}>
                {this.renderTable()}
            </Card>
        )
    }

    componentDidMount(){
        this.getData()
    }

    getData = () => {

        const { 
            page, 
            limit,
            offlineReferenceNumber_search,
            fdTicketNum_search,
            supplierCompanyName_search,
            enterpriseCompanyName_search
        } = this.state

        _paginateSlaDiscprencies({ 
            page, 
            limit,
            offlineReferenceNumber_search,
            fdTicketNum_search,
            supplierCompanyName_search,
            enterpriseCompanyName_search
         })
        .then(_data => {
            this.setState({
                data: _data.data.docs,
                count: _data.data.count
            })
        })
    }

    renderTable = () => {

        const { data, count, limit, page } = this.state

        let columns = [{
            title: 'Date Created',
            dataIndex: 'dateCreated',
            render: (dateCreated) => moment(dateCreated).format('DD MMM YY')
        },{
            title: 'OfflineRef',
            dataIndex: 'offlineReferenceNumber',
            ...this.getColumnSearchProps('offlineReferenceNumber'),
        },{
            title: 'FD Ticket',
            dataIndex: 'fdTicketNum',
            ...this.getColumnSearchProps('fdTicketNum'),
        },{
            title: 'Product',
            dataIndex: 'productTitle'
        },{
            title: 'Supplier',
            dataIndex: 'supplierCompanyName',
            ...this.getColumnSearchProps('supplierCompanyName'),
        },{
            title: 'Enterprise',
            dataIndex: 'enterpriseCompanyName',
            ...this.getColumnSearchProps('enterpriseCompanyName'),
        },{
            title: 'Reason',
            dataIndex: 'reason'
        },{
            title: 'Responsibility',
            dataIndex: 'responsibility'
        }]

        if (this.props.userData && this.props.userData.data && allowedEditors.includes(this.props.userData.data.local.email)) {
            columns.push({
                title: 'Loss',
                dataIndex: 'lossAmount'
            })
            columns.push({
                title: 'PIC',
                dataIndex: 'pic'
            })
            columns.push({
                title: 'Actions',
                render: (action, record) => this.renderActions(record)
            })
        }

        return (
            <Table
                onChange={this.handleTableChange}
                columns={columns}
                dataSource={data}
                pagination={{
                    pageSize: limit,
                    current: page,
                    total: count,
                    onChange: (nextPage) => {
                        this.setState({ page: nextPage })
                    }
                }}
                />
        )
    }

    renderActions = (record) => {
        return (
            <div style={{whiteSpace: 'nowrap'}}>
                <a href={`${ADMIN_URL}/sla/${record._id}`}>View</a>
                <Divider type='vertical'/>
                
                <Popconfirm
                    title="Confirm Delete?"
                    onConfirm={() => this.handleDelete(record._id)}
                >
                    <a >Delete</a>
                </Popconfirm>
            </div>
        )
    }

    handleDelete = (slaId) => {
        _deleteSla({slaId})
        .then(() => {
            this.getData()
        })
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={this.state[`${dataIndex}_search`]}
                    onChange={(e => this.setState({[`${dataIndex}_search`]: e.target.value}))}
                    onPressEnter={() => this.handleSearch(confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(confirm, dataIndex)}
                        icon='search'
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
              </Button>
                    <Button onClick={() => this.handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
                        Reset
              </Button>
            </div>
        ),
        filterIcon: filtered => <Icon type='search' />,
        render: text => text
    });

    handleSearch = (confirm, dataIndex) => {
        confirm();
        // Page is set to 1 because if on handleSearch page==2 but results only has 1 page, cant see any results
        this.setState({
            page: 1
        }, this.getData)
        
    };

    handleReset = (clearFilters, dataIndex) => {
        clearFilters();
        this.setState({ 
            [`${dataIndex}_search`]: '' 
        },this.getData);
        
    };
    
    handleTableChange = (pagination, filters, sorter, extra) => {

        this.setState({
            current: pagination.current,
            entityTypeFilter: filters.entityType,
            verifiedFilter: filters.verified
        }, this.getData)
    }
}

export default connect(
	state => ({
		userData: state.user
	})
)(SlaDiscrepenciesTable);


// WEBPACK FOOTER //
// ./src/components/sla-discrepancies/table.js